import React from 'react';

const RejectIcon: React.FC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.7668 4.70825L11.1834 2.70825C10.8501 2.37492 10.1001 2.20825 9.6001 2.20825H6.43344C5.43344 2.20825 4.3501 2.95825 4.1001 3.95825L2.1001 10.0416C1.68344 11.2083 2.43344 12.2083 3.68344 12.2083H7.01677C7.51677 12.2083 7.93344 12.6249 7.8501 13.2083L7.43344 15.8749C7.26677 16.6249 7.76677 17.4583 8.51677 17.7083C9.18344 17.9583 10.0168 17.6249 10.3501 17.1249L13.7668 12.0416"
                stroke="#6B6969"
                stroke-width="1.5"
                stroke-miterlimit="10"
            />
            <path
                d="M18.0168 4.70833V12.875C18.0168 14.0417 17.5168 14.4583 16.3501 14.4583H15.5168C14.3501 14.4583 13.8501 14.0417 13.8501 12.875V4.70833C13.8501 3.54167 14.3501 3.125 15.5168 3.125H16.3501C17.5168 3.125 18.0168 3.54167 18.0168 4.70833Z"
                stroke="#6B6969"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default RejectIcon;
